import api from './api';

export type ParametroSistema = {
  id: number;
  preProjetoJanelaInicio: string | null;
  preProjetoJanelaFim: string | null;
  preProjetoJanelaFimSecretaria: string | null;
  preProjetoAberto: boolean;
  preProjetoBloqueioMensagem: string | null;
  preProjetoRetificacaoInicio: string | null;
  preProjetoRetificacaoFim: string | null;
  preProjetoRetificacaoAberta: boolean;
  preProjetoCancelamentoInicio: string | null;
  preProjetoCancelamentoFim: string | null;
  preProjetoCancelamentoAberto: boolean;
  transparenciaUnidadeResponsavel: string | null;
  transparenciaContatoEmail: string | null;
  transparenciaContatoTelefone: string | null;
  transparenciaAtoDesignacaoUrl: string | null;
  atualizadoPor: string | null;
  atualizadoEm: string | null;
};

const getParametros = async (): Promise<ParametroSistema> => {
  const response = await api.get('/parametros-sistema');
  return response.data as ParametroSistema;
};

const atualizarJanelaPreProjeto = async (
  dataInicial: string | null,
  dataFinal: string | null,
  dataFinalSecretaria: string | null,
): Promise<ParametroSistema> => {
  const response = await api.put('/parametros-sistema/pre-projeto-janela', {
    dataInicial,
    dataFinal,
    dataFinalSecretaria,
  });
  return response.data as ParametroSistema;
};

const atualizarJanelaRetificacaoPreProjeto = async (
  dataInicial: string | null,
  dataFinal: string | null,
): Promise<ParametroSistema> => {
  const response = await api.put('/parametros-sistema/pre-projeto-retificacao', {
    dataInicial,
    dataFinal,
  });
  return response.data as ParametroSistema;
};

const atualizarJanelaCancelamentoSelecao = async (
  dataInicial: string | null,
  dataFinal: string | null,
): Promise<ParametroSistema> => {
  const response = await api.put('/parametros-sistema/pre-projeto-cancelamento-selecao', {
    dataInicial,
    dataFinal,
  });
  return response.data as ParametroSistema;
};

// Unidade responsável pelo portal da transparência (TAEP P.1). Somente ADMIN.
const atualizarResponsavelTransparencia = async (payload: {
  unidadeResponsavel: string;
  contatoEmail: string;
  contatoTelefone: string;
  atoDesignacaoUrl: string;
}): Promise<ParametroSistema> => {
  const response = await api.put('/parametros-sistema/transparencia-responsavel', payload);
  return response.data as ParametroSistema;
};

export default {
  getParametros,
  atualizarJanelaPreProjeto,
  atualizarJanelaRetificacaoPreProjeto,
  atualizarJanelaCancelamentoSelecao,
  atualizarResponsavelTransparencia,
};
